module.exports = __webpack_public_path__ + "9167f1dbf5d8d9905aa5933a2fc45693.ttf";